import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/main.css';
import Header from './components/Header'
import Photo from './components/Photo';
import OurStory from './components/OurStory';
import Locations from './components/Locations';
import Rsvp from './components/Rsvp';
import Honeymoon from './components/Honeymoon';
import Loader from './components/Loader';
import OnlinePage from './components/OnlinePage';
import InvitePreview from './components/InvitePreview';
import GuestBookPage from './components/GuestBookPage';
import QRCodeDisplayPage from './components/QRCodeDisplayPage';
import Popup from './components/Popup';

function App() {
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        // Simula il caricamento delle risorse
        const timer = setTimeout(() => {
            setLoading(false);
        }, 2500); // Mostra il loader per 2.5 secondi
        
        return () => clearTimeout(timer);
    }, []);

    const HomePage = () => (
        <>
            <Header />
            <Photo />
            <div className="content-container">
                <OurStory />
                <Locations />
                <Rsvp />
                <Honeymoon />
            </div>
            <InvitePreview />
            <Popup />
            {/* Footer Section */}
            <footer className="app-footer">
              <p>Fatto con <span role="img" aria-label="heart">❤️</span> dagli sposi, Alessandro & Ylenia</p>
              <p>Copyright © {new Date().getFullYear()} - Preparatevi a festeggiare!</p>
            </footer>
        </>
    );
    
    return (
        <>
            <Loader isLoading={loading} />
            <div className={`app-container ${!loading ? 'loaded' : ''}`}>
                <Router>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/online" element={<OnlinePage />} />
                        <Route path="/guest-book" element={<GuestBookPage />} />
                        <Route path="/guest-book-qrcode" element={<QRCodeDisplayPage />} />
                    </Routes>
                </Router>
            </div>
        </>
    );
}

export default App;
